<template>
  <div class="w-full">
    <div class="mt-8 flex items-center justify-center">
      <p>
        <strong v-text="$tc('messages.catcher', 1)"></strong>: <span v-text="authUser.username"></span>
      </p>
    </div>

    <div class="w-1/2 mt-8 lg:w-full shadow-inner p-2 bg-gray-300">
      <div v-for="detail in details" class="flex items-center justify-between">
        <label
          class="font-bold"
          v-text="detail.label"
        >
        </label>

        <label
          v-text="detail.value"
        >
        </label>
      </div>
    </div>

    <div v-if="hasGroup" class="mt-8 flex items-center justify-center">
      <p v-html="$t('messages.my_team_is', {group: group.name})">
      </p>
    </div>

    <div v-if="dedicatedTo" class="mt-4 flex items-center justify-center">
      <p v-html="$t('messages.catching_for', {dedicated: dedicatedTo})">
      </p>
    </div>

    <div class="mt-8 flex flex-col items-center justify-center">
      <button
        class="text-white font-semibold py-2 px-4 border rounded shadow"
        :class="[
          hasPointsReadyForRedeems ? 'bg-green-400 hover:bg-green-500 border-green-500' : 'bg-blue-400 hover:bg-blue-500 border-blue-500',
          loading ? 'opacity-50 cursor-not-allowed' : ''
        ]"
        @click.prevent="redeemPoints"
        :disabled="loading"
      >
        <span
          v-text="$t(hasPointsReadyForRedeems ? 'messages.redeem_your_points' : 'messages.no_points_to_redeem')">
        </span>
        <span
          v-if="hasPointsReadyForRedeems"
          class="bg-green-500 px-2 py-1 text-white font-semibold rounded-full"
          v-text="pendingPointsDispay"
        >
        </span>
      </button>

      <pulse-loader
        :loading="loading"
        class="mt-4"
        color="#000000"
        size="10px"/>
    </div>

    <div class="mt-4 flex items-center justify-center">
      <div class="flex items-center">
        <span
          class="bg-gray-400 px-2 py-1 text-white font-semibold rounded-full"
          v-text="pendingRedeems"
        >
        </span>
        <span class="font-semibold ml-2" v-text="$t('messages.pending')">
        </span>
      </div>
    </div>

    <div class="mt-8 flex items-center justify-center">
      <RouterLink
        :to="{ name: 'app.edit_my_profile' }"
        class="underline text-blue-500 text-lg"
        v-text="$t('messages.edit_my_profile')"
      />
    </div>
  </div>
</template>

<script>
import get from 'lodash/get';
import {mapState, mapGetters, mapActions} from 'vuex';
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';

export default {
  components: {
    PulseLoader
  },

  props: {
    aside: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      loading: false
    }
  },

  computed: {
    ...mapGetters('civium', [
      'hasGroup',
      'dedicatedTo'
    ]),

    ...mapState('civium', [
      'group',
      'scoreDetails'
    ]),

    ...mapState('auth', {
      authUser: state => state.user,
    }),

    details() {
      return get(this.scoreDetails, 'details', [])
    },

    pendingRedeems() {
      return get(this.scoreDetails, 'pending_redeems', 0)
    },

    pendingPointsToRedeems() {
      return get(this.scoreDetails, 'pending_points', 0)
    },

    pendingPointsDispay() {
      return get(this.scoreDetails, 'pending_points_display', 0)
    },

    hasPendingRedeems() {
      return this.pendingRedeems > 0;
    },

    hasPointsReadyForRedeems() {
      return this.pendingPointsToRedeems > 0;
    }
  },

  methods: {
    ...mapActions('civium', [
      'performRedeemPoints'
    ]),

    /**
     * Redeem the pending points.
     */
    async redeemPoints() {
      if (this.hasPointsReadyForRedeems) {
        this.loading = true;
        let totalForRedeem = this.pendingPointsToRedeems

        await this.performRedeemPoints()

        this.$swal({
          title: this.$t('messages.good_job'),
          html: this.$t('messages.you_have_redeem_points', {points: totalForRedeem}),
          icon: 'success',
          confirmButtonColor: '#3085d6',
        });

        this.loading = false;
      }
    }
  }
}
</script>
